import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./order_payment_destination.js";
//#region src/order_payment_destination_helper.ts
var order_payment_destination_helper_exports = /* @__PURE__ */ __exportAll({ stringFromEnum: () => stringFromEnum });
function stringFromEnum(paymentDestination) {
	switch (paymentDestination) {
		case 0: return "none";
		case 1: return "credit-card";
		case 2: return "employee-id";
		case 3: return "cashier";
	}
}
//#endregion
export { order_payment_destination_helper_exports, stringFromEnum };

//# sourceMappingURL=order_payment_destination_helper.js.map